// Next
import Image from 'next/image';

import { gsap } from 'gsap';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useEffect, useRef } from 'react';
import { RENDER_DOCUMENT_OPTIONS, imageLoader } from '../../helpers/contentful';

// Components
import Button from '../Button/Button';
import Pattern from '../Pattern/Pattern';
import ScreenWindow from '../ScreenWindow/ScreenWindow';

const ProductHeader = (props) => {
  const { title, description, figureScreen, figureMask, buttons, modifier, pattern } = props;
  const refPatternContainer = useRef();

  const tl = gsap.timeline();

  useEffect(() => {
    tl.to(refPatternContainer.current, { duration: 2, opacity: 1 }, '-=1.1');

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div className={`ProductHeader ${modifier || ''}`}>
      <div className="ProductHeader-inner">
        <div className="ProductHeader-wrapper">
          {(title || description || buttons?.length) && (
            <div className="ProductHeader-text">
              {title && (
                <h1 className="ProductHeader-title">{documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)}</h1>
              )}
              {description && (
                <div className="ProductHeader-description">
                  {documentToReactComponents(description, RENDER_DOCUMENT_OPTIONS)}
                </div>
              )}
              {buttons?.length >= 1 && (
                <div className="ProductHeader-buttonGroup">
                  {buttons.map((button, buttonIndex) => (
                    <Button
                      label={button.label}
                      url={button.url ? button.url : null}
                      modifier={button.modifier}
                      key={`ProductHeader-button--${buttonIndex}`}
                      target={button.target && button.url ? button.target : null}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          {(figureScreen || figureMask) && (
            <div className="ProductHeader-figure">
              {figureScreen.src && (
                <div className="ProductHeader-screenImage">
                  <div className="ProductHeader-screenImageWrap">
                    <Image
                      priority
                      layout="fill"
                      objectFit="contain"
                      objectPosition="bottom left"
                      sizes="(min-width: 1440px) 560px,(min-width: 640px) 50vw, 100vw"
                      loader={imageLoader}
                      src={`https:${figureScreen.src}`}
                      alt={figureScreen.alt}
                    />
                  </div>
                </div>
              )}
              {modifier === 'ProductHeader--abmPage' && <ScreenWindow />}
              {figureMask.src && (
                <div className="ProductHeader-mask">
                  <div className="ProductHeader-maskImage">
                    <div className="ProductHeader-maskImageWrap">
                      <Image
                        priority
                        unoptimized
                        layout="fill"
                        objectFit="contain"
                        objectPosition="bottom left"
                        loader={imageLoader}
                        src={`https:${figureMask.src}`}
                        alt={figureMask.alt}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {pattern && (
        <div className="ProductHeader-patternContainer" ref={refPatternContainer}>
          <Pattern />
        </div>
      )}
    </div>
  );
};

export default ProductHeader;
